import React from 'react';
import { CardData } from '.';
import CopayCard from '../copay/card';
import FtoCard from '../fto/card';
import { ServiceNames } from '../../../../../hoc/constants/service.constants';
import { Service } from '../../../../../hoc/context/product/configuration-model';

const CardFactory: React.FC<{ service: Service; data: CardData; printMode?: boolean }> = ({
    service,
	data,
	printMode = false,
}) => {
    switch (data.type) {
        case ServiceNames.copay:
            return <CopayCard service={service} data={data} printMode={printMode} />
        case ServiceNames.fto:
            return <FtoCard service={service} data={data} printMode={printMode} />
        default:
            return <></>
    }
}

export default CardFactory;